export const iconFontAwesomeAlphabetM = (
	<i className="fa-solid fa-m"></i>
);
